import { create } from "zustand";

const useTaskStore = create((set) => ({
  tasks: [],
  searchQuery: "",

  setTasks: (tasks) => set({ tasks }),

  addTask: (task) =>
    set((state) => ({
      tasks: [...state.tasks, task],
    })),

  updateTask: (id, updatedTask) =>
    set((state) => ({
      tasks: state.tasks.map((task) =>
        task.id === id ? { ...task, ...updatedTask } : task
      ),
    })),

  deleteTask: (id) =>
    set((state) => ({
      tasks: state.tasks.filter((task) => task.id !== id),
    })),

  moveTask: (taskId, newColumn) => set((state) => ({
    tasks: state.tasks.map(task =>
      task.id === taskId ? { ...task, column: newColumn } : task
    )
  })),

  setSearchQuery: (query) => set({ searchQuery: query }),


  getFilteredTasks: (state) => {
    if (!state.searchQuery) return state.tasks;

    const query = state.searchQuery.toLowerCase();
    return state.tasks.filter(
      (task) =>
        task.title.toLowerCase().includes(query) ||
        task.description.toLowerCase().includes(query)
    );
  },
}));

export default useTaskStore;
